
import { environment } from '@environments/environment';
const API_URL = `${environment.API_URL}api/v1.0/`
export const SERVICIO_ADMINISTRACION = {
    acondicionamiento: {
        ver: `${API_URL}administracion/acondicionamiento`,
    }
}